export class ListRestoreJobsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobs",
            "baseName": "jobs",
            "type": "Array<RestoreJob>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreJobsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
